module.exports = __webpack_public_path__ + "static/BillDodson-edea4258f7ef5f3dcecd638821abf324.jpg";